<template>
  <div class="add-box">
    <div class="add">
      <div class="title">
        <Icon type="ios-hand-outline" size="24" />你有手相需要帮忙解读吗？
      </div>
      <Form
        class="form"
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="100"
      >
        <FormItem label="姓名" prop="patientName">
          <Input
            v-model="formValidate.patientName"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem label="性别" prop="gender">
          <RadioGroup v-model="formValidate.gender">
            <Radio
              v-for="(item, index) in genderList"
              :key="index"
              :label="item.value"
              >{{ item.label }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <FormItem label="年龄" prop="patientAge">
          <Input
            v-model="formValidate.patientAge"
            type="number"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem label="手相图片" prop="path">
          <uploadPic v-model="formValidate.path" :typeId="1" />
        </FormItem>
      </Form>
      <div class="footer">
        <Button type="primary" @click="handleSubmit('formValidate')"
          ><Icon type="md-send" />发送</Button
        >
        <div class="tip">
          还有 <span class="red">{{ handExperienceCount }}次</span> 体验机会
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      handExperienceCount: 0,
      genderList: [
        {
          label: "男",
          value: "M",
        },
        {
          label: "女",
          value: "F",
        },
      ],
      formValidate: {
        patientName: "", //患者姓名
        gender: "",
        patientAge: "",
        path: "",
        infoType: 2, //数据类型：infoType 本次需求直接传2
      },
      ruleValidate: {
        patientName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        patientAge: [
          {
            required: true,
            message: "请输入年龄",
            trigger: "blur",
          },
        ],
        path: [
          {
            required: true,
            message: "请上传手相图片",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["handData"]),
  },
  watch: {
    handData: {
      handler(val) {
        this.setHandData();
      },
      immediate: true,
    },
  },
  methods: {
    // 接收到手相数据
    setHandData() {
      // 这里暂时不处理
    },
    async submit() {
      try {
        await this.getHandExperienceCount();
      } catch (error) {}

      if (this.handExperienceCount <= 0) {
        this.$Message.error("体验次数已经用完了哦");
        return;
      }

      let obj = {
        patientCode: dayjs().format("YYYYMMDDHHmmss"),
        registerCode: 1,
        medicalRecordScanDetailDTOList: [
          {
            picUrl: this.formValidate.path,
            picType: 1,
          },
        ],
        registerDatetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        ...this.formValidate,
      };
      this.$store.commit("openSpin");
      this.api2("addMedicalRecordScan", obj)
        .then((res) => {
          let d = res.result.details[0];
          this.getOMLapi(d);
        })
        .catch((err) => {
          this.$store.commit("closeSpin");
        });
    },

    // 调OML接口
    getOMLapi(detail) {
      this.$store.commit("openSpin");
      let picUrl = config.intranetPic + detail.picUrl;
      let params = {
        params: {
          picId: detail.aidId,
          apiUrl: config.omlToCimaiApi,
          picUrl,
          userdata: {
            picUrl,
            picId: detail.aidId,
            patientCode: 8888888,
            sex: this.formValidate.gender == "M" ? 1 : 2, // 1：男 2：女
          },
        },
      };
      this.api2("uploadPictureToOML", params)
        .then((res) => {
          this.$emit("addSuccess");
          this.getHandExperienceCount();
          // this.close();
          this.handleReset("formValidate");
        })
        .catch(() => {})
        .finally(() => {
          this.$store.commit("closeSpin");
        });
    },
    close() {
      this.$emit("close");
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$Message.error("请将表单填写完整!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    getHandExperienceCount() {
      return new Promise((resolve, reject) => {
        this.api2("getHandExperienceCount")
          .then((res) => {
            this.handExperienceCount = res.result.num;
            resolve(this.handExperienceCount);
          })
          .catch(reject);
      });
    },
  },
  mounted() {
    this.getHandExperienceCount();
  },
};
</script>
<style scoped lang="scss">
.add-box {
  height: 100%;
  display: flex;
  align-items: center;
}
.add {
  width: 400px;
  margin: 0 auto;
  .title {
    text-align: center;
    font-weight: bold;
    font-size: 17px;
    margin-bottom: 15px;
  }
  .form {
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #ddd;
    padding: 20px 100px;
    margin-bottom: 25px;
    :deep {
      .ivu-form-item-label {
        text-align: left;
      }
    }
  }
  .footer {
    .ivu-btn {
      width: 100%;
      margin-bottom: 15px;
    }
    .tip {
      text-align: right;
      font-size: 12px;
    }
  }
}
</style>
